import { Deserializable } from '../deserializable';

export class RegisterAsIndividual implements Deserializable {
  email: string;
  fullName: string;
  displayName: string;
  mobile: string;
  idNumber: string;
  incomeTaxNumber: string;
  sarsUsername: string;
  sarsPassword: string;
  accountNumber: number;
  cifNumber: number;
  physicalAddress: string;

  isoCountryCode: string;
  source: string = 'Admin Portal';
  sourceReference: string;
  recaptcha: string;
  brokerId: number;

  createdByUserId: number;

  deserialize(input: any): this {
    Object.assign(this, input);
    return this;
  }
}
